(function () {
    window.NewsGraph = window.NewsGraph || {};

    class NewsGraphAutoRotateController {
        constructor(options = {}) {
            this.enabled = options.enabled !== false;
            this.speed = typeof options.speed === 'number' ? options.speed : 0.0015;
            this.onChange = typeof options.onChange === 'function' ? options.onChange : null;
            this._axis = { x: 0, y: 1, z: 0 };
            this._quat = null;
            this._lastSpeed = null;
        }

        setEnabled(enabled) {
            const next = !!enabled;
            if (this.enabled === next) return this.enabled;
            this.enabled = next;
            if (this.onChange) this.onChange(this.enabled);
            return this.enabled;
        }

        toggle() {
            return this.setEnabled(!this.enabled);
        }

        setSpeed(speed) {
            if (typeof speed === 'number' && Number.isFinite(speed)) {
                this.speed = speed;
            }
        }

        tick(targetObject3D) {
            if (!this.enabled || !targetObject3D) return false;

            const THREE = window.THREE || (window.AFRAME && window.AFRAME.THREE);
            if (!THREE) return false;

            if (!this._quat || this._lastSpeed !== this.speed) {
                const axis = new THREE.Vector3(this._axis.x, this._axis.y, this._axis.z);
                this._quat = new THREE.Quaternion().setFromAxisAngle(axis, this.speed);
                this._lastSpeed = this.speed;
            }

            targetObject3D.quaternion.premultiply(this._quat);
            return true;
        }
    }

    window.NewsGraph.NewsGraphAutoRotateController = NewsGraphAutoRotateController;
})();